const localization = {
  en: {
    print: 'Print',
    medicationUppercase: 'Medication',
    startedOnUppercase: 'Date Started On',
    orderedByUppercase: 'Ordered By',
    instructionsUppercase: 'Instructions'
  },
  es: {
    print: 'Imprimir',
    medicationUppercase: 'Medicamento',
    startedOnUppercase: 'Fecha De Inicio',
    orderedByUppercase: 'Ordenado Por',
    instructionsUppercase: 'Instrucciones'
  },
  keyMapping: {
    print: 'UFD_Print_Button',
    medicationUppercase: 'UFD_Print_Medication',
    startedOnUppercase: 'UFD_Print_Date_Started_On',
    orderedByUppercase: 'UFD_Print_Ordered_By',
    instructionsUppercase: 'UFD_Print_Instructions'
  }
}

export default localization

